(function(){
  if (window.__rtInit) return; window.__rtInit = true;
  document.documentElement.classList.add('rt-js');
  var pad = function(n){ return String(n).padStart(2,'0'); };
  function countdowns(root){
    root.querySelectorAll('[data-rt-countdown]').forEach(function(el){
      if (el.__rt) return; el.__rt = true;
      var t = Date.parse(el.getAttribute('data-rt-countdown'));
      if (isNaN(t)) { el.style.display = 'none'; return; }
      var q = function(s){ return el.querySelector(s); };
      var d=q('[data-d]'), h=q('[data-h]'), m=q('[data-m]'), s=q('[data-s]');
      var iv;
      function tick(){
        var left = Math.floor((t - Date.now())/1000);
        if (left <= 0) { el.classList.add('is-done'); if (iv) clearInterval(iv); return; }
        d.textContent = pad(Math.floor(left/86400));
        h.textContent = pad(Math.floor(left%86400/3600));
        m.textContent = pad(Math.floor(left%3600/60));
        s.textContent = pad(left%60);
      }
      tick(); iv = setInterval(tick, 1000);
    });
  }
  function counters(el){
    el.querySelectorAll('[data-rt-count]').forEach(function(n){
      if (n.__rt) return; n.__rt = true;
      var to = parseInt(n.getAttribute('data-rt-count'),10) || 0, start = null, dur = 1400;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { n.textContent = to; return; }
      function step(ts){ if(!start) start = ts; var p = Math.min(1,(ts-start)/dur); n.textContent = Math.round(to*(1-Math.pow(1-p,3))); if (p<1) requestAnimationFrame(step); }
      requestAnimationFrame(step);
    });
  }
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('is-in'); counters(e.target); io.unobserve(e.target); } });
  }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' }) : null;
  function reveal(root){
    root.querySelectorAll('.rt-reveal, [data-rt-draw], .rt-stock__bar, [data-rt-observe]').forEach(function(el){
      if (el.classList.contains('is-in')) return;
      if (io) io.observe(el); else { el.classList.add('is-in'); counters(el); }
    });
  }
  function init(root){ root = root || document; countdowns(root); reveal(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(); }); else init();
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
